import moment from 'src/services/moment_instance';

export const BACKUP_EVENT_ID = 1;

export const isEncuentroPaidFutureEvent = (event, now) => {
  const isNotBackup = event.id !== BACKUP_EVENT_ID;
  const isPaid = Boolean(event.paidEvent);
  const isFuture = moment.tz(event.date, 'America/Bogota').isAfter(now);

  return isNotBackup && isPaid && isFuture;
};

export const sortEventsByDate = (events) =>
  [...events].sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf());

export const getAssignableFutureEvents = (futureEvents) => {
  const now = moment.tz('America/Bogota');
  const eligibleEvents = futureEvents.filter((event) => isEncuentroPaidFutureEvent(event, now));
  return sortEventsByDate(eligibleEvents);
};

export const getGuestFullName = (guestRow) =>
  `${guestRow?.Guest?.name || ''} ${guestRow?.Guest?.lastName || ''}`.trim();
